import { eNamHocActionTypeDefine } from "../../action-types/category/INamHocActionType";
import { generateActions } from "../generateActions";

export const namHocActions = {
    ...generateActions(eNamHocActionTypeDefine, "NAM_HOC"),
   
}